<script setup>
import { ref, watch } from 'vue'

import { useStore } from '@/wrappers/store'

import HToast from './HToast.vue'

const { mapGetters, mapActions } = useStore()
const { error } = mapGetters('errors')
const { clearError } = mapActions('errors')

watch(
  () => error.value,
  error => {
    if (error) {
      const duration = 10000
      setTimeout(() => {
        clearError()
      }, duration)
      addItem({
        description: error,
        type: 'error',
        duration
      })
    }
  }
)

const items = ref([])

const addItem = ({ description, type = 'error', duration, icon }) => {
  if (description) {
    const key = generateId()
    items.value.push({ key, description, type, icon })

    if (duration) {
      setTimeout(
        key => {
          const index = items.value.findIndex(item => item.key === key)
          removeItem(index)
        },
        duration,
        key
      )
    }
  }
}

const removeItem = index => {
  items.value.splice(index, 1)
}

const generateId = () => {
  return `id-${
    Date.now().toString(36) + Math.random().toString(36).substring(2)
  }`
}

defineExpose({
  addItem
})
</script>

<template>
  <transition-group tag="span" class="notifications" name="notifications">
    <HToast
      v-for="(item, index) in items"
      :key="item.key"
      :description="item.description"
      :icon="item.icon"
      :type="item.type"
      @click="removeItem(index)"
    />
  </transition-group>
</template>

<style lang="scss" scoped>
.notifications {
  align-items: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 20;
  pointer-events: none;
  padding: 0 var(--gl-spacing-04);

  &-enter,
  &-leave-to {
    opacity: 0;
    transform: translateY(-100px);
  }

  &-leave-active {
    position: absolute;
  }
}
</style>
